/* Attenu theme — global.js */
(function () {
  // Mobile menu
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-site-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Variant picker -> price + hidden id + sticky bar
  var form = document.querySelector('[data-product-form]');
  if (form) {
    var priceEl = document.querySelector('[data-product-price]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var radios = form.querySelectorAll('input[name="id"]');
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        var p = r.getAttribute('data-price');
        if (priceEl && p) priceEl.textContent = p;
        if (stickyPrice && p) stickyPrice.textContent = p;
      });
    });

    // Quantity controls
    document.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('input');
        input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
      });
    });
    document.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('input');
        input.value = parseInt(input.value || '1', 10) + 1;
      });
    });

    // Sticky ATC visibility
    var sticky = document.querySelector('[data-sticky-atc]');
    var buyBox = document.querySelector('[data-buy-box]');
    if (sticky && buyBox && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            sticky.classList.remove('is-visible');
            document.body.classList.remove('has-sticky-atc');
          } else {
            sticky.classList.add('is-visible');
            document.body.classList.add('has-sticky-atc');
          }
        });
      }, { rootMargin: '-80px 0px 0px 0px' });
      io.observe(buyBox);
    }
    var stickyBtn = document.querySelector('[data-sticky-submit]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  }

  // Gallery thumbs
  document.querySelectorAll('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      var main = document.querySelector('[data-main-image]');
      if (main) { main.src = t.getAttribute('data-full'); main.alt = t.alt || ''; }
    });
  });
})();

/* Sales carousel */
(function () {
  var car = document.querySelector('[data-carousel]');
  if (!car) return;
  var slides = car.querySelectorAll('[data-slide]');
  var thumbs = car.querySelectorAll('[data-goto]');
  var idx = 0;
  function show(n) {
    if (!slides.length) return;
    idx = (n + slides.length) % slides.length;
    slides.forEach(function (s, i) { s.hidden = i !== idx; s.classList.toggle('is-active', i === idx); });
    thumbs.forEach(function (t) { t.classList.toggle('is-active', parseInt(t.getAttribute('data-goto'), 10) === idx); });
  }
  var prev = car.querySelector('[data-carousel-prev]');
  var next = car.querySelector('[data-carousel-next]');
  if (prev) prev.addEventListener('click', function () { show(idx - 1); });
  if (next) next.addEventListener('click', function () { show(idx + 1); });
  thumbs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-goto'), 10)); }); });
})();
